import classNames from "classnames";
import moment from "moment";
import React from "react";
import {
	TBallastBackendRecord,
	TBallastRecord,
} from "../../../../../redux/app/ballast/@types";
import { TBallast_Ballast } from "../../../../../redux/app/ballast/groups/ballast";
import CommaSeparator from "../../../../_common/CommaSeparator";
import BallastRecordParticipantsView from "../_elements/ParticipantsView";

import BallastTableRows from "../_elements/BallastTableRows";
import getSignTableRows from "../_elements/getSignTableRows";
import { TBallast_Cleaning } from "redux/app/ballast/groups/cleaning";

import versions from "../../../../../redux/app/ballast/versions";

type OwnProps = {
	ballastRecord: TBallastRecord;
	isStrikedOff?: boolean;
};
type InternalOperationPreviewProps = OwnProps;
function CleaningOperationPreview(props: InternalOperationPreviewProps) {
	const record = props.ballastRecord as TBallast_Cleaning;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	function renderMain() {
		return (
			<BallastTableRows
				record={record}
				tableRows={[
					[operationDate, "G", "1", renderItem1()],
					[null, null, "2", renderItem2()],
					[null, null, "3", renderItem3()],
					[null, null, "4", renderItem4()],
					[null, null, "5", renderItem5()],
					[null, null, "NOTE", record.remarks],
				]}
			/>
		);
	}

	// MEPC.369(80)
	function renderItem1() {
		const smtStartDate = record.startDateTime.date;
		const smtStartTime = record.startDateTime.time;
		if (record.timeZone) {
			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtStartDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )} */}{" "}
							at Lat {record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_RECEPTION_FACILITY" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtStartDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )} */}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							{record.startDateTime.time} hrs (UTC)
							{/* on{' '}
                            {moment(
                                record.startDateTime.date,
                                'YYYY-MM-DD'
                            ).format('DD-MMM-YYYY')} */}{" "}
							at Lat {record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_RECEPTION_FACILITY" ? (
						<>
							{record.startDateTime.time} hrs (UTC)
							{/* on{' '}
                            {moment(
                                record.startDateTime.date,
                                'YYYY-MM-DD'
                            ).format('DD-MMM-YYYY')} */}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
				</>
			);
		}
	}
	function renderItem2() {
		const smtEndDate = record.endDateTime.date;
		const smtEndTime = record.endDateTime.time;
		if (record.timeZone) {
			const dateTimeLocal = `${smtEndDate}T${smtEndTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtEndDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )} */}{" "}
							at Lat {record.placeOfBallast.endPosition.latitude} / Long{" "}
							{record.placeOfBallast.endPosition.longitude}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_RECEPTION_FACILITY" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtEndDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )} */}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							{record.endDateTime.time} hrs (UTC)
							{/* on{' '}
                            {moment(
                                record.endDateTime.date,
                                'YYYY-MM-DD'
                            ).format('DD-MMM-YYYY')} */}{" "}
							at Lat {record.placeOfBallast.endPosition.latitude} / Long{" "}
							{record.placeOfBallast.endPosition.longitude}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_RECEPTION_FACILITY" ? (
						<>
							{record.endDateTime.time} hrs (UTC)
							{/* on{' '}
                            {moment(
                                record.endDateTime.date,
                                'YYYY-MM-DD'
                            ).format('DD-MMM-YYYY')} */}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
				</>
			);
		}
	}
	function renderItem3() {
		let tankNames = "";
		record.tanks.forEach((tank, index) => {
			tankNames += tank.selectedTank.tankCode;
			if (index !== record.tanks.length - 1) {
				tankNames += ",";
			}
		});
		return tankNames;
	}
	function renderItem4() {
		if (record.placeOfBallast.place === "AT_RECEPTION_FACILITY") {
			return (
				<h4 className="font-medium uppercase">
					{record.totalOperatedWaterVolume}M³, sediments disposed to{" "}
					{record.placeOfBallast.receptionFacilityName} reception facility
				</h4>
			);
		} else {
			return <h4 className="font-medium uppercase">-----</h4>;
		}
	}
	function renderItem5() {
		if (record.placeOfBallast.place === "AT_SEA") {
			return (
				<h4 className="font-medium uppercase">
					{record.totalOperatedWaterVolume}M³ of tank flushing including
					sediments discharged to sea at minimum distance of{" "}
					{record.minimumDistance} nm and minimum depth of {record.depth}m
				</h4>
			);
		} else {
			return <h4 className="font-medium uppercase">-----</h4>;
		}
	}

	return renderMain();
}

export default CleaningOperationPreview;
